enum KendraPluginTypes {
    SET_KENDRA_PLUGIN_STATE = 'SET_KENDRA_PLUGIN_STATE',
}

export default KendraPluginTypes;